// src/pages/Home.jsx
import React from "react";
import Hero from "../components/Hero";
import PropertyCard from "../components/PropertyCard";
import { properties } from "../data/properties";
import { useNavigate } from "react-router-dom";
import "../Styles/Home.css";

const Home = () => {
  const navigate = useNavigate();

  const topProperties = properties.slice(0, 15); // fetch ONLY 15

  return (
    <div className="home-page">
      <Hero />

      {/* PROPERTY SECTION */}
      <section className="home-property-section">
        <div className="section-title-wrapper">
          <h2 className="section-title">Our Top Properties</h2>
        </div>
        

        <div className="home-property-grid">
          {topProperties.map((prop) => (
            <PropertyCard key={prop.id} property={prop} />
          ))}
        </div>

        {/* EXPLORE BUTTON */}
        <div className="explore-btn-wrapper">
          <button
            className="explore-btn"
            onClick={() => navigate("/properties")}
          >
            Explore All Properties ({properties.length})
          </button>
        </div>
      </section>
    </div>
  );
};

export default Home;
